import {Base,Axios} from "@/api/Base"

export class PaymentReportPersistency extends Base {
    path = "payment/reportPersistency";
}